<template>
  <v-container class="pa-0 site-content">
    <v-progress-circular
      v-if="searching || refreshing"
      indeterminate
    ></v-progress-circular>
    <div v-else>
      <h1 class="content-title">Search Results</h1>
      <div v-if="searchResults.length">
        <div v-for="item in searchResults" :key="item.uuid">
          <hcm-news-card
            v-if="item.type === 'NewsItem'"
            :resource="item"
          ></hcm-news-card>
          <hcm-audio-summary-card
            v-else-if="item.type === 'AudioItem'"
            :resource="item"
          ></hcm-audio-summary-card>
          <hcm-video-summary-card
            v-else-if="item.type === 'VideoItem'"
            :resource="item"
          ></hcm-video-summary-card>
          <hcm-text-summary-card
            v-else-if="item.type === 'TextItem'"
            :resource="item"
          ></hcm-text-summary-card>
          <hcm-faq-answer-card
            v-else-if="item.type === 'QuestionAnswerItem'"
            :resource="item"
          ></hcm-faq-answer-card>
          <div v-else>
            {{ item }}
          </div>
        </div>
      </div>
      <div v-else>
        <h4 class="no-results">No results found</h4>
      </div>
    </div>
  </v-container>
</template>

<script>
import { uniq, orderBy, without } from "lodash";
import HCMNewsCard from "../components/HCMNewsCard.vue";
import HCMAudioSummaryCard from "../components/HCMAudioSummaryCard.vue";
import HCMVideoSummaryCard from "../components/HCMVideoSummaryCard.vue";
import HCMTextSummaryCard from "../components/HCMTextSummaryCard.vue";
import HCMFAQAnswerCard from "../components/HCMFAQAnswerCard.vue";
import { stopWords } from "../utils/contentfulParser.js";

export default {
  components: {
    "hcm-news-card": HCMNewsCard,
    "hcm-audio-summary-card": HCMAudioSummaryCard,
    "hcm-video-summary-card": HCMVideoSummaryCard,
    "hcm-faq-answer-card": HCMFAQAnswerCard,
    "hcm-text-summary-card": HCMTextSummaryCard
  },
  created() {
    this.refreshData();

    this.searchTerms = this.$route.query.q;
    this.loadSearchResults();

    this.pageTrack(
      this.$router.currentRoute.path,
      "Search Results: " + this.searchTerms
    );
  },
  data: () => ({
    searchTerms: null,
    searching: false,
    searchResults: []
  }),
  beforeRouteUpdate(to, from, next) {
    this.searchTerms = to.query.q;
    this.loadSearchResults();

    this.pageTrack(
      this.$router.currentRoute.path,
      "Search Results: " + this.searchTerms
    );

    next();
  },
  computed: {
    analyticsOn() {
      return this.$store.get("analyticsOn");
    }
  },
  watch: {
    refreshing: function(val) {
      if (!val) {
        this.loadSearchResults();
      }
    },
    analyticsOn: function(val) {
      if (val) {
        this.pageTrack(
          this.$router.currentRoute.path,
          "Search Results: " + this.searchTerms
        );
      }
    }
  },
  methods: {
    loadSearchResults() {
      if (!this.refreshing) {
        console.log("searching...");
        this.searching = true;

        if (this.searchTerms.trim() !== "") {
          let searchIndex = Object.keys(this.$store.get(`searchItems`));
          let ids = [];
          without(
            this.searchTerms
              .trim()
              .toLowerCase()
              .split(/[\W/]+/),
            ...stopWords
          ).forEach(o => {
            searchIndex.forEach(element => {
              // console.log("ooo", element);

              if (element.includes(o)) {
                let si = this.$store.get(`searchItems@${element}`);

                if (si !== undefined) {
                  ids = [...ids, ...si];
                }
              }
            });
          });

          // let ids = [];
          // this.searchTerms.trim().toLowerCase().split(/[\W/]+/).forEach(o => {
          //   let si = this.$store.get(`searchItems@${o}`);

          //   if (si !== undefined) {
          //     ids = [...ids, ...si];
          //   }
          // });

          // now need to grab each news item/resource item that matches the search term
          let items = [];
          uniq(ids).forEach(o => {
            let si = this.$store.get(`newsItems@${o}`);

            if (si === undefined) {
              si = this.$store.get(`resourceItems@${o}`);
            } else {
              // flag this as a NewsItem
              si.type = "NewsItem";
            }

            items.push(si);
          });

          this.searchResults = orderBy(
            items,
            o => {
              return o.postingDate;
            },
            "desc"
          );
        } else {
          this.searchResults = [];
        }

        this.searching = false;
      }
    }
  }
};
</script>

<style scoped>
.content-title {
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
  font-weight: bold;
  font-size: 26px;
  padding-bottom: 10px;
  margin: 20px 0px;
  text-shadow: 0 1px 1px #5a6566;
}

.no-results {
  color: #ffffff;
  font-weight: 500;
  font-size: 20px;
  padding-bottom: 10px;
  margin: 20px 0px;
}

.site-content {
  max-width: 690px;
}
</style>
